<script lang="ts">
    import {storeID, uuid, viewedProduct} from "../store/store";
    import Button from "./Button.svelte";
    import {fly} from 'svelte/transition';

    let edit = false;
    let tempUUID = $uuid;
    let tempStore = $storeID;
    let tempProduct = $viewedProduct;

    $:if (!edit) {
        tempStore = $storeID;
        tempUUID = $uuid;
        tempProduct = $viewedProduct;
    }

    const onEdit = () => {
        edit = true;
    }

    const onDone = () => {
        edit = false;

        localStorage.setItem("saved-uuid", tempUUID.trim());
        localStorage.setItem("saved-store-id", String(tempStore).trim());
        localStorage.setItem("saved-product", String(tempProduct).trim());

        window.location.reload();
    }

    const onCancel = () => {
        edit = false;
    }

    const onReset = () => {
        localStorage.removeItem("saved-uuid");
        localStorage.removeItem("saved-store-id");
        localStorage.removeItem("saved-product");
        window.location.reload();
    }

</script>
    <div class="info" in:fly={{y: 50, duration: 500}}>
        <h2>{edit ? "Edit Site" : "View"}</h2>
        <div>
            <label for="uuid">UUID:</label>
            {#if edit}
                <input bind:value={tempUUID} type="text" id="uuid"/>
            {:else}
                <input readonly value={$uuid} type="text" id="uuid">
            {/if}
        </div>
        <div>
            <label for="store-id">Store ID:</label>
            {#if edit}
                <input bind:value={tempStore} type="number" id="store-id"/>
            {:else}
                <input readonly value={$storeID} type="number" id="store-id">
            {/if}
        </div>
        <div>
            <label for="product">Viewed Product:</label>
            {#if edit}
                <input bind:value={tempProduct} type="text" id="product"/>
            {:else}
                <input readonly value={$viewedProduct} type="text" id="product">
            {/if}
        </div>
        <div>
            {#if edit}
                <Button onClick="{onDone}" type="accept">Done</Button>
                <Button onClick="{onCancel}" type="decline">Cancel</Button>
            {:else}
                <Button onClick="{onEdit}">Edit</Button>
                <Button onClick="{onReset}" type="secondary">Reset</Button>
            {/if}
        </div>
    </div>

<style>
    .info {
        position: fixed;
        bottom: 15px;
        right: 15px;
        text-align: left;
        border: 1px solid #eee;
        padding: 15px;
        margin: 15px;
        border-radius: 4px;
        width: 320px;
    }

    h2 {
        margin: 0 0 10px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    label {
        font-weight: bold;
    }

    input {
        width: 100%;
    }
</style>